import { useContext } from "react"
import { EnvContext } from "../components/EnvContext"

export const useRouter = () => {
  const env = useContext(EnvContext)
  if (!env) throw new Error("EnvContext not found")
  return env.router
}
